/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Page Reports Subscriber component
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { InfoBlock } from '@components/common';
import Title from '@components/common/Title/Title';
import { EColorStatus } from '@modules/app/appConstants';
import PageLocale from '@modules/internationalization/components/PageLocale';
import { TranslationFileNamesEnum } from '@modules/internationalization/constants';
import { makeSelectTranslationPageSubscriberMobile } from '@modules/internationalization/intSelectors';
import { ECommonTranslationPages } from '@modules/internationalization/types/common/pages';
import { initialise, useTableInitialise } from '@modules/table';

import CorporatePagePortal from '../CorporatePage/CorporatePagePortal';
import { SubscriberMobileTableStatusStyled } from '../PageSubscriberMobile/components/styled/PageSubscriberMobileStyled';
import TableSubscriber from './components/TableReportsSubscriber';
import { TableReportsSubscribersTitle } from './components/TableReportsSubscriberTitle';
import { REPORTS_SUBSCRIBERS_TABLE_CONFIG } from './constants';
import { useTableListStatusCheck } from './hooks/useTableListStatusCheck';

export const PageReportsSubscriber = () => {

    const dispatch = useDispatch();

    const pageTranslation = useSelector(makeSelectTranslationPageSubscriberMobile());

    const { isComplete } = useTableListStatusCheck();

    const { updatedConfig } = useTableInitialise(REPORTS_SUBSCRIBERS_TABLE_CONFIG);

    useEffect(() => {
        if (isComplete && updatedConfig) {
            dispatch(initialise(updatedConfig));
        }
    }, [dispatch, isComplete, updatedConfig]);

    return (
        <>
            <PageLocale lazy fileNames={[TranslationFileNamesEnum.pageSubscriberMobile]} />
            <Title pageName={ECommonTranslationPages.reportsConstructorSubscribers} />
            <TableReportsSubscribersTitle />
            {
                !isComplete && (
                    <CorporatePagePortal>
                        <SubscriberMobileTableStatusStyled>
                            <InfoBlock
                                className='subscriber-mobile__table-status-info'
                                colorStatus={EColorStatus.WARNING}
                            >
                                {pageTranslation.infoTableUpdate}
                            </InfoBlock>
                        </SubscriberMobileTableStatusStyled>
                    </CorporatePagePortal>
                )
            }
            <TableSubscriber />
        </>
    );
};
